module.exports = __webpack_public_path__ + "static/media/logo.97ea6948.png";